
import { useRef } from "react";
import ReactTooltip from "react-tooltip";
import Icon from "../../general/Icon";
import MaterialCard from "../MaterialCard";
import ActivityHoverContent from "../ActivityHoverContent";

const MaterialList = ({
  materialList = [],
  hoverConfig = {},
}) => {
  const tooltipId = useRef(
    `activity-tooltip-${Math.random().toString(36).slice(2)}`
  ).current;

  const materialsById = new Map(
    materialList
      .filter(Boolean)
      .map((material) => [String(material.activityid), material])
  );

  return (
    <div>
      <div className="flex flex-wrap gap-3 px-4 py-2">
        {materialList.filter(Boolean).map((material) => (
          <MaterialCard
            key={material.activityid}
            material={material}
            tooltipId={tooltipId}
            icon={
              <Icon size={40} type={material.activitytype} />
            }
          />
        ))}
      </div>

      <ReactTooltip
        id={tooltipId}
        effect="solid"
        place="top"
        delayShow={300}
        backgroundColor="#FFFDF7"
        textColor="#242424"
        border
        borderColor="#E1D7C4"
        className="!rounded-lg !shadow-lg !p-3 !opacity-100"
        getContent={(activityId) => {
          const material = materialsById.get(activityId);
          if (!material) return null;

          return (
            <ActivityHoverContent
              material={material}
              config={hoverConfig}
            />
          );
        }}
      />
    </div>
  );
};

export default MaterialList;
